module.exports = __webpack_public_path__ + "img/success_5.94d2a33e.gif";